import React from 'react';
import PropTypes from 'prop-types';
import { Card, Tab, Nav } from 'react-bootstrap';

import { messages as jobmessages, debtorStatusMessages } from '../views/Job/Job.messages';
import PaymentDetails from './PaymentDetails';

const SubJobs = (props) => {
    const lng = props.intl.formatMessage;

    // subjobs 
    return (
        <>
            {props.job.members !== null && (
                <Card className='fullwidth-mobile subjobs grey-bottom-border-mobile'>
                    <Card.Body>
                        <h3 className='card-title' id="heading-job-members">
                            {lng(jobmessages.jobMembers)}
                        </h3>
                        <p>{lng(jobmessages.jobMembersDescription)}</p>
                        <Tab.Container defaultActiveKey={props.job.members[0].jobid}>
                            <Nav variant="pills" className='pb-4 pt-1'>
                                {props.job.members.map((subjob, index) => (
                                    <Nav.Item eventKey={subjob.jobid} title={subjob.jobid} key={'tab-member-' + index} >
                                        <Nav.Link
                                            eventKey={subjob.jobid}
                                            title={subjob.jobid}
                                            key={'tab-member-' + index}
                                            style={{ backgroundColor: props.buttonColor, color: props.buttonTextColor, borderColor: props.buttonColor }}
                                            bsPrefix={props.buttonColor ? 'nav-link whitelabel' : ''}
                                        >
                                            {subjob.jobid}
                                        </Nav.Link>
                                    </Nav.Item>
                                ))}
                            </Nav>
                            <Tab.Content>
                                {props.job.members.map((subjob, index) => (
                                    <Tab.Pane eventKey={subjob.jobid} title={subjob.jobid} key={'tab-member-' + index} >
                                        <ul className='list-unstyled'>
                                            <li id='subjob-paymentdetails' className='accordion-listitem'>
                                                <PaymentDetails
                                                    subjob={subjob}
                                                    openamount={subjob.openamount}
                                                    {...props}
                                                />
                                            </li>
                                            <li>
                                                <span className='label'>{lng(jobmessages.jobid)}</span>
                                                <span className='float-end'>{subjob.jobid}</span>
                                            </li>
                                            <li id='subjob-billnum'>
                                                <span className='label'>{lng(jobmessages.billNum)}</span>
                                                <span className='float-end'>{subjob.billnum ? subjob.billnum : '-'}</span>
                                            </li>
                                            {/* possible debtor status messages for sub jobs */}
                                            {typeof debtorStatusMessages['statuscode' + subjob.statuscode] !== "undefined" && debtorStatusMessages['statuscode' + subjob.statuscode] !== "" &&
                                                <li id='subjob-statusmessage'>
                                                    <span className='label'>{lng(jobmessages.statusLabel)}</span>
                                                    <span className='float-end'>{lng(debtorStatusMessages['statuscode' + subjob.statuscode])}</span>
                                                </li>
                                            }
                                            <li id='subjob-reference'>
                                                <span className='label'>{lng(jobmessages.reference)}</span>
                                                <span className='float-end'>{subjob.reference}</span>
                                            </li>
                                            <li id='subjob-creditor'>
                                                <span className='label'>{lng(jobmessages.creditor)}</span>
                                                <span className='float-end'> {subjob.payee.name}</span>
                                            </li>
                                        </ul>
                                    </Tab.Pane>
                                ))}
                            </Tab.Content>
                        </Tab.Container>
                    </Card.Body>
                </Card>
            )}
        </>
    );
};

SubJobs.propTypes = {
    'intl': PropTypes.object.isRequired,
    'job': PropTypes.object,
    'buttonColor': PropTypes.string,
    'buttonTextColor': PropTypes.string
};

export default SubJobs;